<template>
  <div>
    <form action=""
    class="z-2 bg-beige-academy-300 p-6">
      <div class="text-center text-black font-bold text-xl">
        {{ $t('lessonsPrices.title').toUpperCase() }}</div>
      <div class="text-center text-black font-light italic mt-1 font-xs">
        {{ $t('lessonsPrices.subtitle') }}</div>
      <div class="flex flex-row mt-10 items-center">
        <div class="mr-4 flex-grow-1">{{ $t('lessonsPrices.currency') }} </div>
        <custom-select-currency v-model="prices.currency" />
      </div>
      <div class="flex flex-row items-center mt-10">
        <div class="mr-4 flex-grow-1">{{ $t('lessonsPrices.single') }} </div>
        <input
          type="text"
          class="w-1/6 outline-none text-right"
          v-model="prices.lesson_price">.00
            <div class="px-1 flex items-center" v-if="prices.currency!=='Choose your currency'">
              <img :src="`/images/currencies/${prices.currency}.svg`"
                :alt="prices.currency" class="w-2">
            </div>
            <div class="px-1">*</div>

      </div>
      <div class="flex flex-row mt-5">
        <div class="mr-4 flex-grow-1">{{ $t('lessonsPrices.extra') }} </div>
        <input
          type="text"
          class="w-1/6 outline-none text-right"
          v-model="prices.lesson_with_extra_price">.00
            <div class="px-1 flex items-center" v-if="prices.currency!=='Choose your currency'">
              <img :src="`/images/currencies/${prices.currency}.svg`"
                :alt="prices.currency" class="w-2">
            </div>
            <div class="px-1">*</div>
      </div>
      <div class="flex flex-row mt-5">
        <div class="mr-4 flex-grow-1">{{ $t('lessonsPrices.package') }} </div>
        <input
          type="text"
          class="w-1/6 outline-none text-right"
          v-model="lessons_package_price">.00
            <div class="px-1 flex items-center" v-if="prices.currency!=='Choose your currency'">
              <img :src="`/images/currencies/${prices.currency}.svg`"
                :alt="prices.currency" class="w-2">
            </div>

      </div>
      <div class="flex flex-row mt-10">
        <div class="text-center text-gray-600 font-light italic mt-1 font-xs">
        * {{ $t('lessonsPrices.required') }}</div>
      </div>
    </form>
    <div class="flex flex-row justify-center">
      <button
        @click="savePrices"
        class="bg-orange-academy-300 text-grey-academy-100 px-4 py-1 m-4 rounded self-center
        border border-orange-academy-300 hover:text-orange-academy-300 hover:bg-white">
          {{ $t('lessonsPrices.save') }}
        </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CustomSelectCurrency from '@/components/CustomSelectCurrency.vue';
import axios from 'axios';

export default {
  data() {
    return {
      lessons_package_price: 0,
      prices: {
        currency: 'Choose your currency',
        lesson_price: 0,
        lesson_with_extra_price: 0,
        lessons_package_price: null,
      },

    };
  },

  components: {
    CustomSelectCurrency,
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
    }),
  },

  methods: {
    async savePrices() {
      this.$emit('close');
      if (this.lessons_package_price != null) {
        this.prices.lessons_package_price = this.lessons_package_price;
      }

      console.log(this.prices);
      await axios.post(`/api/teacher/${this.user.id}/prices`, this.prices);

      this.$router.go();
    },

  },
};
</script>
